import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import PageWithLayout from 'src/components/layout/PageWithLayout';
import { AnnotationLabelTable } from 'src/features/annotation_label/components/AnnotationLabelTable';
import { RootState } from 'src/store';

const AnnotationLabelPage: React.FC = () => {
	const { siteSlug } = useParams<{
		siteSlug: string;
	}>();

	const siteDetails = useSelector(
		(state: RootState) => state.site.siteDetails,
	);

	const breadcrumbs = [
		{
			label: siteDetails?.name || 'Site Details',
			href: `/site/${siteSlug}`,
		},
		{ label: 'Annotation Labels' },
	];

	return (
		<PageWithLayout breadcrumbs={breadcrumbs}>
			<AnnotationLabelTable />
		</PageWithLayout>
	);
};

export default AnnotationLabelPage;
